<template>
  <b-modal :active="show" @close="modalClose" :width="640">
    <!-- <h1>{{ $t('general.voucher') }} {{ currentVoucher.idSstItem }}</h1> -->
    <div class="card">
      <div class="card-content">
        <!-- <div
          class="notification is-warning has-text-weight-bold"
        >{{$t('printing.warning')}}</div> -->
        <b-notification auto-close type="is-success" :closable="false" :active.sync="showSuccess" aria-close-label="Schließen">{{ $t('notices.data-successfully-saved') }}</b-notification>
        <VoucherModalUser :readonly="voucher.fulfilled" :user="voucherData.customer" @request-save="updateCustomerData" @request-download="downloadVoucher" />
        <!-- <b-button
          type="is-primary"
          @click="downloadVoucher"
        >Gutschein drucken</b-button> -->
        <b-loading :is-full-page="false" :active.sync="voucherData.isLoading" :can-cancel="false"></b-loading>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VoucherApi from '@/api/voucher-api'
import VoucherModalUser from './VoucherModalUser'
export default {
  name: 'VoucherModal',
  props: {
    voucher: Object,
    token: String,
    id: String,
    show: Boolean,
  },
  components: {
    VoucherModalUser,
  },
  data() {
    return {
      currentVoucher: {},
      showSuccess: false,
      voucherData: {
        customer: {},
        isLoading: true,
      },
    }
  },
  watch: {
    show() {
      if (this.show && this.voucher.id) {
        this.loadVoucher()
      }
    },
  },
  methods: {
    async loadVoucher() {
      this.voucherData.isLoading = true
      this.voucherData.customer = await VoucherApi.retriveCustomer(this.id, this.token, this.voucher.idSstItem)
      this.voucherData.isLoading = false
    },
    async updateCustomerData() {
      this.voucherData.isLoading = true
      const customer = await VoucherApi.updateCustomer(this.id, this.token, this.voucher.idSstItem, this.voucherData.customer)
      this.voucherData.customer = customer
      this.showSuccess = true
      this.voucherData.isLoading = false
    },
    async downloadVoucher() {
      this.voucherData.isLoading = true
      if (!this.voucher.fulfilled) {
        await this.updateCustomerData()
      }
      try {
        await VoucherApi.downloadVoucher(this.id, this.token, this.voucher.idSstItem, this.voucherData.customer)
        this.voucher.fulfilled = true
      }catch {
        this.$store.dispatch('flashMessageDanger', { message:  this.$t('errors.retryable-error')})
      }
 
      this.voucherData.isLoading = false
   
    },
    modalClose() {
      this.$emit('close-request')
    },
  },
}
</script>

<style scoped lang="sass"></style>
